import { LionMark } from "./LionMark";

const links = [
  { href: "#overview", label: "The Guesthouse", id: "nav-link-overview" },
  { href: "#suites", label: "Suites", id: "nav-link-suites" },
  { href: "#dining", label: "Dining & Bar", id: "nav-link-dining" },
  { href: "#booking", label: "Reservations", id: "nav-link-booking" },
];

export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="sticky top-0 z-50 bg-[#F7F6F2]/95 backdrop-blur-md border-b border-[#E3DFD5] px-8 py-5"
  >
    <div className="max-w-7xl mx-auto flex items-center justify-between">
      <a href="#hero" data-testid="nav-brand-link" className="flex items-center gap-3">
        <LionMark />
        <div>
          <span className="block font-editorial text-base tracking-wider uppercase font-semibold text-[#1A1A18]">
            tseyaakuku.com
          </span>
          <span className="block font-mono-tag text-[9px] tracking-[0.2em] text-[#9E7D4E] uppercase">
            Otjiwarongo • Namibia
          </span>
        </div>
      </a>

      <div className="hidden md:flex items-center gap-10 font-grotesk text-xs uppercase tracking-[0.15em] text-[#55524A]">
        {links.map((l) => (
          <a
            key={l.id}
            href={l.href}
            data-testid={l.id}
            className="hover:text-[#1A1A18] transition-colors"
          >
            {l.label}
          </a>
        ))}
      </div>

      <a
        href="#booking"
        data-testid="nav-book-now-button"
        className="px-6 py-2.5 border border-[#1A1A18] text-[#1A1A18] font-grotesk text-xs uppercase tracking-[0.14em] hover:bg-[#1A1A18] hover:text-white transition-colors"
      >
        Book Now
      </a>
    </div>
  </nav>
);
